import { render, staticRenderFns } from "./ActionHint.vue?vue&type=template&id=2a986836&scoped=true&"
import script from "./ActionHint.vue?vue&type=script&lang=js&"
export * from "./ActionHint.vue?vue&type=script&lang=js&"
import style0 from "./ActionHint.vue?vue&type=style&index=0&id=2a986836&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a986836",
  null
  
)

export default component.exports